import React, { useContext } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import { ReactComponent as RRLogo } from 'images/rr-logo.svg';

export default function LogoStamp() {
  const { storeProperties } = useContext(AuthContext);

  const isSSR = _get(storeProperties, 'is_ssr_retailer', false);

  if (isSSR) return null;

  return (
    <div
      className="logo-stamp-wrapper"
      onClick={() => {
        window.open('https://www.returnrabbit.com', '_blank').focus();
      }}
    >
      <RRLogo />
    </div>
  );
}
